module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag10_0492AT.b29e11e5.jpg";